import React, {Component} from "react";

// import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

class MapContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (typeof window === 'undefined') {
            return;
        }

        const container = document.getElementById('mapContainer');
        if (!container) {
            return;
        }

        const mapContainer = document.getElementById('mapContainer');
        const yandexMapScript = document.createElement('SCRIPT');
        yandexMapScript.setAttribute('src', 'https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3Afdda76d575029aec6f84af6ec6c6f1e521ae0a84fff5a099cce78dd1824826ad&amp;lang=ru_RU&amp;scroll=true');
        yandexMapScript.setAttribute('async', '');
        yandexMapScript.setAttribute('defer', '');
        yandexMapScript.setAttribute('charset', 'utf-8');
        mapContainer.appendChild(yandexMapScript);
    }

    render() {
        return null
    }
}

export default MapContainer;


// WEBPACK FOOTER //
// ./src/js/components/MapContainer.js